<template>
    <div class="header">

        <div class="container">
            <div class="row">
                <div class="col-md-2">
                    <div class="header__logo">
                        <Logo/>
                    </div>
                </div>
                <div class="col-md-10">
                    <MainNavigation/>
                </div>
            </div>
        </div>
        <div class="mobile">
            <div class="hamburger-menu">
                <div class="bar"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Logo from './header/Logo.vue'
    import MainNavigation from './header/MainNavigation.vue'
    export default {
        name: 'Header',
        components: {
            Logo,
            MainNavigation
        }
    }
</script>


<style lang="scss">
    @import "../assets/styles/components/header.scss";
</style>